import DashboardDataTable from './DashboardDataTable';

export default DashboardDataTable;
